import analytics from "web/script/analytics/analytics";

export function sendAnalyticsEvent(
    label: string,
    isInteraction: boolean,
    productId: string,
    buyOptionId: string | null
): void {
    analytics.event({
        category: "product_gallery",
        action: "engagement",
        label,
        nonInteraction: !isInteraction,
        itemData: [{ product_id: productId, buy_option_id: buyOptionId }],
    });
}
